import ProMember from './ProMember';
import NoResultsPanel from './NoResultsPanel';
import React from "react";
import ExperienceMember from "./ExperienceMember";
import FavoriteItem from "./FavoriteItem";
export default function ResultsLoading(props) {

    const HitLoads = () => {
        return (
            <div className="individuals__item">
                <div className="individual">
                    <div className="individual__inner">
                        <span style={{backgroundColor: '#e2e2e2', width: '78px', height: '78px'}}></span>
                        <div className="individual__content">
                            <div className="individual__head">
                                <span style={{width: '400px', height: '29px', display:'block', backgroundColor: '#e2e2e2'}}></span>
                            </div>

                            <div className="individual__title"
                                 style={{width: '475px', height: '15px', marginTop: '8px', backgroundColor: '#e2e2e2'}}>
                                <span style={{width: '246px', height: '15px', marginTop: '8px', backgroundColor: '#e2e2e2'}}></span>
                            </div>
                        </div>
                    </div>

                    <aside className="individual__aside">
                        <div className="individual__actions">
                        </div>
                    </aside>
                </div>
            </div>
        );
    }


    let loadingRows = [];
    for (var i = 0; i < 12; i++) {
        // note: we are adding a key prop here to allow react to uniquely identify each
        // element in this array. see: https://reactjs.org/docs/lists-and-keys.html
        loadingRows.push(<HitLoads key={i} />);
    }

    return (
        <div className="individuals form__individuals">
            <h6></h6>
            <div className="individuals__items">
                {loadingRows}
            </div>
        </div>
    )
}
